import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ErrorResponse } from './classes/error';
import { OneToNVerify } from './classes/one-to-n-enroll';

@Component({
  selector: 'jaakrecog-verify',
  template: `
    <lib-capture-video
      *ngIf="showComponent"
      [accessToken]="accessToken"
      (getResult)="emitResult($event)"
    ></lib-capture-video>
  `,
  styles: [],
})
export class VerifyComponent implements OnInit {
  @Input() accessToken!: string;
  @Output() getResponse: OneToNVerify | ErrorResponse | any =
    new EventEmitter();
  showComponent: boolean = true;
  constructor() {
    let scriptTag = document.createElement('script');
    scriptTag.src =
      'https://storage.googleapis.com/jaakrecog-storage-front/js/face-api.min.js';
    document.body.appendChild(scriptTag);
  }

  ngOnInit(): void {}
  emitResult(ev: any): void {
    this.showComponent = false;
    this.getResponse.emit(ev);
    setTimeout(() => {
      this.showComponent = true;
    }, 1000);
  }
}
